import React from "react";
import get from "lodash/get";
import { Link } from "@quintype/components";
import { object } from "prop-types";
import { format } from "date-fns";

import Headline from "../../atoms/headline";
import ClockIcon from "../../atoms/icons/clock";

import "./key-highlights.m.css";

function getTitleElement(elements) {
  return elements.find(element => element.type === "title");
}

function titleText(card) {
  const text = getTitleElement(card["story-elements"]);
  return text ? text.text : "";
}

const goToCard = cardId => {
  if (cardId) {
    setTimeout(function() {
      document.getElementById(cardId) &&
        document.getElementById(cardId).scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest"
        });
    }, 100);
  }
};

const KeyHighlight = ({ highlight }) => (
  <li styleName="list-key" onClick={() => goToCard(highlight.card.id)}>
    <span styleName="clock-icon">
      <ClockIcon color="#ba0406" width={20} height={20} />
    </span>
    <time styleName="time">{format(new Date(highlight.card["card-added-at"]), "D MMMM YYYY, hh:mm A")}</time>
    <Headline text={highlight.title} headerType={15} headerLevel={4} />
  </li>
);

const KeyHighlights = props => {
  const { story } = props;
  const keyhighlights = story.cards
    .filter(card => get(card, ["metadata", "attributes", "key-event"], false))
    .map(card => {
      return { title: titleText(card), card };
    });

  return keyhighlights.length > 0 ? (
    <div styleName="wrapper">
      <Link styleName="section-name">
        <Headline text="Key Events" headerType={13} headerLevel={3} />
      </Link>
      <ul styleName="list">
        {keyhighlights.slice(0, 5).map(highlight => (
          <KeyHighlight key={`highlight-${highlight.card.id}`} highlight={highlight} />
        ))}
      </ul>
    </div>
  ) : null;
};

KeyHighlight.propTypes = {
  highlight: object
};

KeyHighlights.propTypes = {
  story: object
};

export default KeyHighlights;
